/**
 *
 * Provides our client side phone validation
 */

import StringValidation from './String';

/**
 * Uses same regex as backend!
 * Make sure it consistent if going to change it
 */
const PHONE_REGEX = /(\d.*){9}/;

export const isValid = (phone: string | null | undefined) => {
  if (phone === null || !StringValidation.isString(phone)) return false;

  return PHONE_REGEX.test(phone);
};

const DUTCH_PHONE_REGEX = /^\+31\d{9}$/;

/**
 * Checks if the phone number is a valid Dutch phone number
 *
 * Example mobile: +31612345678
 * Example landline: +31202223571
 *
 * @param phone - The phone number to check
 * @returns True if the phone number is a valid Dutch phone number, false otherwise
 */
const isValidDutchPhoneNumber = (phone: string | null | undefined) => {
  if (phone === null || !StringValidation.isString(phone)) return false;
  return DUTCH_PHONE_REGEX.test(phone);
};

export default {
  isValid,
  isValidDutchPhoneNumber,
};
